export const APP_INITIALIZE_DONE = "APP_INITIALIZE_DONE"
export const APP_INITIALIZE_FAILED = "APP_INITIALIZE_FAILED"
export const APP_CLIENT_CHANGED = "APP_CLIENT_CHANGED"
export const APP_MAIL_PERFORMED = "APP_MAIL_PERFORMED"
export const APP_MAIL_UNSET_POST_PACKAGE = "APP_MAIL_UNSET_POST_PACKAGE"
export const APP_POST_PACKAGE_POST_CODE_CHANGED = "APP_POST_PACKAGE_POST_CODE_CHANGED"
export const APP_POST_PACKAGE_GROUP_CREATED = "APP_POST_PACKAGE_GROUP_CREATED"
export const APP_ACCOUNT_CREATED = "APP_ACCOUNT_CREATED"
export const APP_ACCOUNT_CREATE_FAILED = "APP_ACCOUNT_CREATE_FAILED"
export const APP_POSTINDEX_CREATED = "APP_POSTINDEX_CREATED"
export const APP_POSTINDEX_CREATE_FAILED = "APP_POSTINDEX_CREATE_FAILED"
export const APP_MAIL_PERFORM_DELETED = "APP_MAIL_PERFORM_DELETED"
